<div 
    [agprLoading]="loading"
    #chartGroupElement
    class="agpr-chartGroup"
    [attr.id]="id ? id + '.chartGroup' : null"
></div>
